import { useState } from 'react'
import { useMsal } from '@azure/msal-react'
import { getConfig } from '../configs/config'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { loginRequest } from '../authConfig'
export interface DeleteDataProps {
  url: string
  type: any
  body?: any
}

export const useDelete: any = (app = 'inv') => {
  const { accounts, instance } = useMsal()
  const config = getConfig()
  const [isLoading, setLoader] = useState(false)

  const getScopeForApp = (app: string) => {
    return app === 'nexus' || app === 'semanticdata'
      ? config.REACT_NEXUS_AZURE_SCOPE
      : config.REACT_APP_AZURE_SCOPE
  }

  const request = {
    ...loginRequest,
    scopes: [getScopeForApp(app)],
    account: accounts[0]
  }

  const deleteData = async ({ url, type, body }: DeleteDataProps) => {
    setLoader(true)
    const msalResponse = await instance.acquireTokenSilent(request).catch((e: any) => {
      if (e instanceof InteractionRequiredAuthError) {
        instance.acquireTokenRedirect(request)
      }
    })

    const options = {
      method: 'delete',
      headers: {
        Accept: 'application/json',
        ...(app !== 'nexus' &&
          app !== 'semanticdata' &&
          app !== 'invdesktop' && { 'Content-Type': 'application/json' }),
        Authorization: `Bearer ${msalResponse?.accessToken}`
      },
      ...(body && { body: JSON.stringify(body) })
    }

    try {
      const baseUrl =
        app === 'nexus'
          ? config?.REACT_NEXUS_API_URL
          : app === 'semanticdata'
          ? config?.REACT_SEMANTIC_API_URL
          : config?.REACT_APP_API_URL

      const endpoint = `${baseUrl}${url}`
      const res = await fetch(endpoint, options)
      setLoader(false)
      return res
    } catch (error) {
      setLoader(false)
      return error
    }
  }

  return [isLoading, deleteData] as const
}
